module.exports = __webpack_public_path__ + "static/media/blocker_must.38e51858.png";